module.exports = __webpack_public_path__ + "img/piscada.2145d08c.png";